<template>
    <div class="select_date">
        <el-select v-model="month" class="month" placeholder="Month" >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
        <el-input v-model="day" class="day" placeholder="Day" clearable />
        <el-input v-model="year" class="year" placeholder="Year" clearable />
    </div>
</template>

<script>
export default {
    name: 'SelectDate',
    model: {
        prop: 'value',
        event: 'custom'
    },
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
    },
    data() {
        return {
            options: [
                {label: 'January', value: '1'},
                {label: 'February', value: '2'},
                {label: 'March', value: '3'},
                {label: 'April', value: '4'},
                {label: 'May', value: '5'},
                {label: 'June', value: '6'},
                {label: 'July', value: '7'},
                {label: 'August', value: '8'},
                {label: 'September', value: '9'},
                {label: 'October', value: '10'},
                {label: 'November', value: '11'},
                {label: 'December', value: '12'},
            ],
            month: '',
            year: '',
            day: '',
        }
    },
    computed: {
        date() {
            return `${this.year}-${this.month}-${this.day}`
        }
    },
    watch: {
        value: function(val) {
            if (!val) { return }
            const data = val.split('-')
            this.month = data[1] || ''
            this.year = data[0] || ''
            this.day = data[2] || ''
        },
        date: function(val) {
            this.$emit('custom', val)
        }
    }
}
</script>

<style lang="scss" scoped>
.select_date {
    .el-input {
        display: inline-flex;
    }
    .month {
        width: 133px;
        margin-right: 8px;
    }
    .day {
        width: 100px;
        margin-right: 8px;
    }
    .year {
        width: 114px;
    }
}
</style>